// extracted by mini-css-extract-plugin
module.exports = {"container":"FAQPageSections_container__2V7TK"};